import { render } from "./BaseView.vue?vue&type=template&id=736d200a"
import script from "./BaseView.vue?vue&type=script&lang=js"
export * from "./BaseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__